export default {
  'globalPreferenceSettings.title': '基础设置',
  'globalPreferenceSettings.section.language': '语言设置',
  'globalPreferenceSettings.block.languageSwitch': '语言开关设置',
  'globalPreferenceSettings.languageSwitch.forPOS': 'POS',
  'globalPreferenceSettings.languageSwitch.forKiosk': 'Kiosk点餐',
  'globalPreferenceSettings.languageSwitch.forQRCode': 'QR点餐',
  'globalPreferenceSettings.languageSwitch.forTablet': '平板点餐',
  'globalPreferenceSettings.languageSwitch.forOnlineOrdering': '线上平台',
  'globalPreferenceSettings.languageSwitch.forWaitlist': '排队',
  'globalPreferenceSettings.languageSwitch.forLoyaltyWeb': '会员入会页',
  'globalPreferenceSettings.languageSwitch.forCFG': '客显屏',

  'globalPreferenceSettings.languageSwitch.update.success': '更新语言开关设置成功!',
  'globalPreferenceSettings.languageSwitch.update.fail': '更新语言开关设置失败!',
};
